import React from 'react'

import { Route, Switch } from 'react-router-dom'

import { useReloadIdleUser } from 'common/hooks/use-reload-idle-user'

import OrderDetail from 'vendor/pages/Public/OrderDetail/order_detail'

const Public = (props) => {
  useReloadIdleUser()

  return (
    <Switch>
      <Route path="/vendors/order/:id">
        <OrderDetail companyVendorContactId={props['companyVendorContactId']} />
      </Route>
    </Switch>
  )
}

export default Public
